export default class DrawingSpine extends PIXI.spine.Spine {
	constructor(spineData, name = null, texName = null) {
		super(spineData);


		this._name = name;
		this._texName = texName;
		this._hacks = {};
	}

	destroy() {
		super.destroy({children: true});
	}

	deleteHacks() {
		for (const i in this._hacks) {
			if (this._hacks.hasOwnProperty(i)) {
				const hack = this._hacks[i];
				hack.destroy();
			}
		}
	}

	update(dt) {
		super.update(dt);
		//this._updateTextureHacks();           // disabled for now. I don't think we'll be using Noise and this clashed with the redo functionality.
	}

	_updateTextureHacks() {
		for (const i in this._hacks) {
			if (this._hacks.hasOwnProperty(i)) {
				const hack = this._hacks[i];
				hack.time += hack.animationSpeed * P3.Ticker.dt;

				const frames = hack.frames;
				const round = (hack.time + 0.5) | 0;

				hack.time = hack.time % frames.length;
				const frame = frames[round % frames.length];
				if (frame.texture !== hack.texture) {
					hack.texture = frame.texture;
					this.hackTextureBySlotName(hack.slotName, frame.texture, frame.texture.orig);
					this.setSlotAnchor(hack.slotName, frame.anchor.x, frame.anchor.y);
				}
			}
		}
	}

	addTextureHack(hack) {
		const frame = hack.frames[0];
		hack.texture = frame.texture;
		this.hackTextureBySlotName(hack.slotName, frame.texture, frame.texture.orig);
		this.setSlotAnchor(hack.slotName, frame.anchor.x, frame.anchor.y);
		this._hacks[hack.slotName] = hack;
	}

	setSlotAnchor(slotName, x, y) {
		const slot = this.skeleton.findSlot(slotName);
		slot.currentSprite && slot.currentSprite.anchor.set(x, y);
	}

	get hacks() {
		return this._hacks;
	}

	get name() {
		return this._name;
	}
}